var CheckoutSelfPickupJs = (function ($) {
    var $radioButtons;
    var $clickElem;

    var hasContent = function(sel){
        return true && (sel) && $(sel).html().trim();
    };
    var initShowHideSelfPickup = function (radioButtonsSel,selPickupId) {
        var radioBSel = radioButtonsSel + " input[type='radio']";
        showHideSelfPickupDeliveryAddress($(radioBSel + '[name=deliveryMethod]:checked'),selPickupId);
        $(radioBSel).on("click", function () {
            showHideSelfPickupDeliveryAddress($(this),selPickupId);
        });
    };
    var showHideSelfPickupDeliveryAddress = function(target,selPickupId) {
        if (target.attr("value") === selPickupId) {
                $(".j-warehouse-details").show();
        }else{
             $(".j-warehouse-details").hide();
        }
    };
    return {
        initShowHideSelfPickup: initShowHideSelfPickup,
        showHideSelfPickupDeliveryAddress: showHideSelfPickupDeliveryAddress
    }
}) (jQuery);

$(document).ready(function() {
    var selPickupId = $("#selfPickupDeliveryRadioButton").val();
    if (typeof selPickupId !== 'undefined') {
        CheckoutSelfPickupJs.initShowHideSelfPickup(".j-delivery-method-radio-buttons",selPickupId);
    }
});